// components/Cart/ShoppingCart.js
import React from 'react';
import styles from '../../ChatApp.module.css';
import { CloseIcon, getProductImageUrl } from '../../utils/AppHelpers';

const TAX_RATE = 0.00; 

const ShoppingCart = React.memo(({ cart, onUpdateQuantity, onRemoveItem, onImageClick, onCheckout }) => {
    const { items = [], subtotal = 0, tax = 0, total = 0 } = cart;
    
    const handleQuantityChange = (sku, value) => {
        const quantity = parseInt(value, 10);
        if (quantity >= 0) onUpdateQuantity(sku, quantity);
    };
    
    if (!items || items.length === 0) {
        return <div className={styles.cartEmpty}>Your cart is empty.</div>;
    }
    return (
        <>
            <div className={styles.cartContent}>
                {items.map(item => {
                     const imageUrl = getProductImageUrl(item);
                    return (
                        <div key={item.sku} className={styles.cartItem}>
                            <div className={styles.cartItemDetails}>
                                <img
                                    src={imageUrl}
                                    alt={item.name || 'Unnamed Item'}
                                    className={styles.cartItemImage}
                                    onClick={() => imageUrl && onImageClick(imageUrl)}
                                    onError={(e) => { e.target.src = `https://via.placeholder.com/300x300.png?text=No+Img`; e.target.onerror = null; }}
                                />
                                <div className={styles.cartItemInfo}>
                                    <div className={styles.cartItemName}>{item.name || 'Unnamed Item'}</div>
                                    <div className={styles.cartItemPrice}>${(item.price || 0).toFixed(2)} each</div>
                                    <div className={styles.cartItemSubtotal}>Sub: ${(item.subtotal || 0).toFixed(2)}</div>
                                </div>
                            </div>
                            <div className={styles.cartItemControls}>
                                <input type="number" min="0" className={styles.cartQuantityInput} value={item.quantity} onChange={(e) => handleQuantityChange(item.sku, e.target.value)} />
                                <button className={styles.removeButton} title="Remove item" onClick={() => onRemoveItem(item.sku)}>
                                    <CloseIcon style={{width: 18, height: 18}} />
                                </button>
                            </div>
                        </div>
                    );
                 })}
            </div>
            <div className={styles.cartTotals}>
                <div className={styles.totalsRow}>
                    <span>Subtotal:</span>
                    <span>${subtotal.toFixed(2)}</span>
                </div>
                <div className={styles.totalsRow}>
                    <span>Tax ({ (TAX_RATE * 100).toFixed(0) }%)</span>
                    <span>${tax.toFixed(2)}</span>
                </div>
                <div className={styles.totalsRowBold}>
                    <span>Total:</span>
                    <span>${total.toFixed(2)}</span>
                </div>
            </div>
            
            <div className={styles.cartFooter}>
                <button
                    className={styles.checkoutButton}
                    onClick={onCheckout}
                    disabled={!items || items.length === 0}
                >
                    Proceed to Checkout
                </button>
            </div>
        </>
    );
});

export default ShoppingCart;